import React from 'react';

export const PricingSummary = ({ subtotal }) => (
  <>
    <div className="flex justify-between items-center mb-2">
      <span className="text-gray-600">Subtotal:</span>
      <span className="font-semibold text-gray-700" data-testid="cart-subtotal">${subtotal.toFixed(2)}</span>
    </div>
    <div className="flex justify-between items-center mb-2">
      <span className="text-gray-600">PA Tax (6%):</span>
      <span className="font-semibold text-gray-700">${(subtotal * 0.06).toFixed(2)}</span>
    </div>
    <div className="flex justify-between items-center mb-2">
      <span className="text-gray-600">Service Fee (4%):</span>
      <span className="font-semibold text-gray-700">${(subtotal * 0.04).toFixed(2)}</span>
    </div>
    <div className="bg-yellow-100 border border-yellow-300 rounded-lg p-2 mb-3 text-center">
      <p className="text-xs text-yellow-800">Delivery fee will be calculated based on location. Invoice with final total will be sent.</p>
    </div>
    <div className="flex justify-between items-center mb-2 pt-2 border-t border-orange-300">
      <span className="text-xl font-bold text-violet-700">Total:</span>
      <span className="text-2xl font-bold heading-font text-orange-600" data-testid="cart-total">${(subtotal * 1.10).toFixed(2)}</span>
    </div>
    <p className="text-xs text-gray-500 text-center mb-3">+ Delivery (calculated separately)</p>
  </>
);
